module.exports = __webpack_public_path__ + "img/product_54.ccb2f7e.webp";